import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CanActivateAuthGuard, initRouteData, Permission, CanActivatePermissionGuard } from 'sc-common';
import { ForbiddenComponent } from 'sc-external/shared/components/error/forbidden/403-forbidden.component';
import { NotFoundComponent } from 'sc-external/shared/components/error/not-found/404-not-found.component';
import { ServerErrorComponent } from 'sc-external/shared/components/error/server-error/500-server-error.component';

const routes: Routes = [
    {
        path: 'forbidden',
        component: ForbiddenComponent
    },
    {
        path: 'not-found',
        component: NotFoundComponent
    },
    {
        path: 'server-error',
        component: ServerErrorComponent
    },
    {
        path: '',
        canActivate: [CanActivateAuthGuard],
        children: [
            {
                path: 'author',
                canActivate: [CanActivatePermissionGuard],
                data: initRouteData({ hasPermission: Permission.EditingToolAuthorView }),
                loadChildren: () => import('./modules/authors/authors.module').then(x => x.AuthorsModule)
            },
            {
                path: 'editor',
                canActivate: [CanActivatePermissionGuard],
                data: initRouteData({ hasPermission: Permission.EditingToolEditorView }),
                loadChildren: () => import('./modules/editors/editors.module').then(x => x.EditorsModule)
            },
            {
                path: 'reviewer',
                canActivate: [CanActivatePermissionGuard],
                data: initRouteData({ hasPermission: Permission.EditingToolReviewerView }),
                loadChildren: () => import('./modules/reviewers/reviewers.module').then(x => x.ReviewersModule)
            },
            {
                path: '',
                redirectTo: '/not-found',
                pathMatch: 'full'
            }
        ]
    },
    {
        path: '**',
        redirectTo: '/not-found'
    }];

@NgModule(
    {
        imports: [RouterModule.forRoot(routes)],
        exports: [RouterModule]
    })
export class AppRoutingModule { }
